import {BaseWrapper} from '../../framework/parameters/BaseWrapper';
import {BasicCriteria} from '../../framework/parameters/BasicCriteria';
import {BasicScenario} from '../../framework/parameters/BasicScenario';
import {Currency} from '../message/Currency';

export class CurrencyWrapper extends BaseWrapper<Currency, BasicCriteria, BasicScenario>  {}

